// WHO PAID — one partner, or both with each one's part (migration 069).
//
// Shared by the expense dialog and the mark-as-paid dialog, so recording a paid cost and
// settling an unpaid one ask the same question the same way. The state lives in the
// dialog (utils/payers `initialPayerState`) because the dialog sends it; this renders it.
//
// Choosing "both" starts at half each — the common case — and typing either part fills
// the other with what is left of the amount, so the two add up without arithmetic. When
// they do not (the amount was edited afterwards, say) the field says what they must add up
// to, and the dialog keeps Save dark: the server would refuse it anyway, and the gap is
// exact only when every paid expense's parts add up to its amount.
import he from '../i18n/he';
import { NumberInput, Select } from './Form';
import { formatMoney } from './Money';
import { BOTH, halves, withRemainder, splitAddsUp } from '../utils/payers';

export default function PayerSplitField({ label, partners, amount, state, onChange }) {
  const list = partners || [];
  const options = [
    ...list.map((p) => ({ value: p.id, label: p.name })),
    ...(list.length > 1 ? [{ value: BOTH, label: he.expenses.payersBoth }] : []),
  ];
  const choose = (e) => {
    const who = e.target.value;
    onChange(who === BOTH ? { who, parts: halves(amount, list) } : { who, parts: {} });
  };
  const setPart = (partnerId) => (e) =>
    onChange({ ...state, parts: withRemainder(state.parts, partnerId, e.target.value, amount, list) });

  return (
    <>
      <Select label={label} value={state.who} onChange={choose} options={options} />
      {state.who === BOTH && list.map((p) => (
        <NumberInput
          key={p.id}
          label={he.expenses.payerPart(p.name)}
          value={state.parts[p.id] ?? ''}
          onChange={setPart(p.id)}
        />
      ))}
      {!splitAddsUp(state, amount, list) && (
        <p className="field-error">{he.expenses.payerSplitMismatch(formatMoney(amount))}</p>
      )}
    </>
  );
}
